export default {
  default: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">free Scentbird travel Bag,<br />Travel Spray & Case</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">free Scentbird travel Bag,<br />Travel Spray & Case</span>',
    },
    description: {
      en: `
        Eligible customers will receive a Scentbird travel Bag, Travel Spray & Case
        for free with any ecommerce purchase of {subTotal} or more. One gift per customer.
        While supplies last. Offer applied automatically at checkout.
      `,
    },
  },
  fathersDay: {
    remain: {
      en: `
        You\'re <span class="text-gold-50 font-bold">{remain}</span> away from
        <span class="text-gold-50 font-bold">FREE gift!</span>
      `,
    },
    earned: {
      en: 'You\'ve earned a <span class="text-gold-50 font-bold">FREE GIFT</span>',
    },
    description: {
      en: `
        Eligible customers will receive a free Confessions of a Rebel GET A ROOM Body Wash
        with any ecommerce purchase of {subTotal} or more. One gift per customer.
        While supplies last. Offer applied automatically at checkout.
      `,
    },
  },
}
